import React, { Component } from 'react';
import HomeCover from 'components/Components/Pages/HomePage/HomeCover';
import HomeContent from 'components/Components/Pages/HomePage/LoadableHomeContent';
import Fade from 'react-reveal/Fade';
import { withLayout } from '../../Layouts/ThemeContext/with-layout';


class HomePage extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            revealed: false,
        };
    }

    componentDidMount()
    {
        this.props.themeContext.configHeader({
            defaultBg: 'header-transparent',
            defaultBurgerPosition: 'burger-transparent',
            showDatesForm: true,
            showQuoteButton: true,
            customScheduleCallButton: undefined,
        });
    }

    render()
    {
        const { revealed } = this.state;

        return (
            <>
                <HomeCover />

                <Fade bottom onReveal={() => this.setState({ revealed: true })}>
                    {revealed && <HomeContent /> }
                </Fade>
            </>

        );
    }
}

HomePage.defaultProps = {};

export default withLayout(HomePage);
